import Title from "../../typography/Title/Title";
import Body from "../../typography/Body/Body";
import {
  StyledContactLink,
  StyledUnprotectedFooter,
} from "./UnprotectedFooter.module";

export type UnprotectedFooterProps = {
  position?: string;
};

const UnprotectedFooter = ({ position }: UnprotectedFooterProps) => {
  return (
    <StyledUnprotectedFooter position={position}>
      <div>
        <Title size="small" bold pd="0 0 0.5rem 0">
          Submitting work to Brand Compliance?
        </Title>
        <Body size="large">
          Log in or create an account to access the submission form.
        </Body>
      </div>

      <div>
        <Title size="small" bold pd="0 0 0.5rem 0">
          Need help?
        </Title>
        <Body size="large">
          For any questions or concerns,{" "}
          <StyledContactLink
            href="mailto:support@brandcentral.verizon.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-us"
          >
            contact us.
          </StyledContactLink>
        </Body>
      </div>
    </StyledUnprotectedFooter>
  );
};

export default UnprotectedFooter;
